<template>
  <div>
    <div class="link-warp">
      <div class="link-item active">{{ $route.query.domainName }} 域名解析</div>
      <Button class="goback btn-height45" to="/user/domain">返回</Button>
    </div>
    <div class="section">
      <div class="table-data">
        <div class="total rows">
          搜索结果（{{ searchObj.total }}）
          <div>
            <Button
              class="btn-height45"
              style="margin-right: 20px"
              @click="onAdd"
              >添加解析记录</Button
            ><Button class="btn-height45" @click="onBatchDelete"
              >批量删除</Button
            >
          </div>
        </div>
        <Table
          ref="domainTable"
          class="domain-table"
          :columns="columns"
          :data="data"
          :loading="tableLoading"
        >
          <template slot="status" slot-scope="{ row }">
            <div>
              {{ row.status === 1 ? "正常" : "暂停" }}
            </div>
          </template>
          <template slot="action" slot-scope="{ row }">
            <div class="rows">
              <Button @click="onEdit(row)">修改</Button>
              <Button
                style="margin-left: 6px"
                v-if="row.status == 1"
                @click="onSuspend(row.id)"
                >暂停</Button
              >
              <Button
                style="margin-left: 6px"
                v-if="row.status == 2"
                @click="onEnable(row.id)"
                >启用</Button
              >
              <Button style="margin-left: 6px" @click="onDelete(row.id)"
                >删除</Button
              >
            </div>
          </template>
        </Table>
        <div class="page-tool">
          <Page
            :current="searchObj.page"
            :total="searchObj.total"
            :page-size="searchObj.limit"
            @on-change="onPageChange"
          />
        </div>
      </div>
    </div>
    <addAnalysisModal
      :show.sync="addAnalysisModalVisibility"
      :title="$route.query.domainName"
      :type="type"
      :data="analysisData"
      @submit-success="onSuccess"
    ></addAnalysisModal>
  </div>
</template>

<script>
import {
  resolutionList,
  resolutionRecordStart,
  resolutionRecordPause,
  resolutionRecordRemove,
} from "api/user.js";
import addAnalysisModal from "components/domain/addAnalysisModal.vue";
export default {
  name: "analysis",
  components: {
    addAnalysisModal,
  },
  data() {
    return {
      columns: [
        {
          type: "selection",
          title: "全选",
          width: 60,
          align: "center",
        },
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "主机记录",
          align: "center",
          key: "host",
        },
        {
          title: "记录类型",
          align: "center",
          key: "type",
        },
        {
          title: "记录值",
          align: "center",
          key: "value",
        },
        {
          title: "线路类型",
          align: "center",
          key: "routeName",
        },
        {
          title: "MX优先级",
          width: 100,
          align: "center",
          key: "mxValue",
        },
        {
          title: "TLL",
          width: 100,
          align: "center",
          key: "ttl",
        },
        {
          title: "更新时间",
          align: "center",
          key: "updatedAt",
        },
        {
          width: 100,
          title: "状态",
          align: "center",
          slot: "status",
        },
        {
          width: 220,
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      searchObj: {
        page: 1,
        limit: 20,
        total: 0,
      },
      data: [],
      tableLoading: false,
      addAnalysisModalVisibility: false,
      type: 0,
      analysisData: {},
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          DId: this.$route.query.id,
          page: this.searchObj.page,
          limit: this.searchObj.limit,
        };
        this.tableLoading = true;
        const { code, data } = await resolutionList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.onPageChange(1);
    },
    // 启用操作
    onEnable(id) {
      this.$Modal.confirm({
        title: "操作确认",
        content: "<p>确定要开始解析操作吗？</p>",
        onOk: async () => {
          const { code, result } = await resolutionRecordStart(id);
          if (code === 200 && result) {
            this.$Message.success("操作成功!");
            this.req_getList();
          }
        },
      });
    },
    //暂停
    onSuspend(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>您确定要暂停解析操作吗?</p>",
        onOk: async () => {
          const { code, result } = await resolutionRecordPause([id]);
          if (code === 200 && result) {
            this.$Message.success("操作成功!");
            this.req_getList();
          }
        },
        onCancel: () => {},
      });
    },
    // 批量删除事件
    onBatchDelete() {
      const selection = this.$refs.domainTable.getSelection();
      if (selection.length === 0) {
        this.$Message.warning("请选择要删除的域名!");
        return false;
      }
      this.onDeleteReq(selection.map((o) => o.id));
    },
    //删除事件
    onDelete(id) {
      this.onDeleteReq([id]);
    },
    //删除请求
    onDeleteReq(recordIds) {
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除解析操作吗?</p>",
        onOk: async () => {
          const { code } = await resolutionRecordRemove(recordIds);
          if (code === 200) {
            this.$Message.success("删除成功!");
            this.req_getList();
          }
        },
        onCancel: () => {},
      });
    },
    // 修改
    onEdit(val) {
      this.addAnalysisModalVisibility = true;
      this.type = 1;
      this.analysisData = val;
    },
    // 添加解析
    onAdd() {
      this.addAnalysisModalVisibility = true;
      this.type = 0;
      this.analysisData = { id: this.$route.query.id };
    },
    // 添加成功
    onSuccess(callback) {
      this.req_getList();
      callback(true);
    },
  },
};
</script>
<style lang="less" scoped>
.link-warp {
  position: relative;
  background-color: #fff;
  padding: 0 30px;
  .link-item {
    display: inline-block;
    height: 80px;
    line-height: 80px;
    margin: 0 30px;
    color: #333;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.3s;
    }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    &::before {
      width: 100%;
      background-color: #3992e9;
    }
  }
  .goback {
    position: absolute;
    top: 50%;
    right: 60px;
    transform: translateY(-50%);
  }
}
.condition-section {
  margin: 40px 0 0;
  background-color: #fff;
  padding: 40px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.rows {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.section {
  background-color: #fff;
  border-radius: 8px;
  margin: 50px;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #f0f3f6;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 80px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
